/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Post = {
    properties: {
        content: {
            type: 'string',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        userMedia: {
            type: 'array',
            contains: {
                type: 'any-of',
                contains: [{
                    type: 'Video',
                }, {
                    type: 'Image',
                }],
            },
            isRequired: true,
        },
        match: {
            type: 'SingleLeagueMatch',
            isRequired: true,
        },
        likes: {
            type: 'array',
            contains: {
                type: 'UserId',
            },
            isRequired: true,
        },
        author: {
            type: 'UserSmall',
            isRequired: true,
        },
        created: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        deleted: {
            type: 'boolean',
            isRequired: true,
        },
        amountComments: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
